/**
 * String utility functions
 */

/**
 * Converts kebab-case or snake_case to camelCase
 * @param value - The string to convert (e.g., "history-stories", "History-Stories", "cybersecurity_safety")
 * @returns The camelCase string (e.g., "historyStories", "cybersecuritySafety")
 * @example
 * toCamelCase("history-stories") // returns "historyStories"
 * toCamelCase("History-Stories") // returns "historyStories"
 * toCamelCase("cybersecurity_safety") // returns "cybersecuritySafety"
 */
export function toCamelCase(value: string | null | undefined): string {
  if (!value) return '';

  return value
    .toLowerCase() // Normalize to lowercase first
    .split(/[-_]/)
    .map((word, index) =>
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join('');
}
